import { render, staticRenderFns } from "./DialogDraftPortalSelection.vue?vue&type=template&id=5b69aa88&"
import script from "./DialogDraftPortalSelection.vue?vue&type=script&lang=js&"
export * from "./DialogDraftPortalSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports